import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Styles.css';
import twitterIcon from '../../assets/icons/lwIndia.png';
import kcIcon from '../../assets/icons/kingschat.png';
import kcConfIcon from '../../assets/icons/Kingsconference.png';
import fccIcon from '../../assets/icons/fcc.png';

const SidebarToggle = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [showMeetings, setShowMeetings] = useState(false);
  const [announcements, setAnnouncements] = useState([
    { id: 1, title: '2026 Year of manifestation', subtitle: 'Embrace the glory of His appearing', icon: '🎉' },
    { id: 2, title: 'November - Month of "Comfort"', subtitle: '2 Corinthians 1:3: "Praise be to the God and Father of our Lord Jesus Christ, the Father of compassion and the God of all comfort."', icon: '🙏' },
    { id: 3, title: 'Early Morning Prayer', subtitle: 'Join us daily at 5:30 AM', icon: '⏰' }
  ]);

  const API_BASE = process.env.REACT_APP_API_URL || 'https://ceindiazone2.in';

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/announcements/active`).catch(() => null);
        if (response && response.ok) {
          const data = await response.json();
          if (data && Array.isArray(data) && data.length > 0) {
            setAnnouncements(data);
          }
        }
      } catch (error) {
        // Fallback to default announcements silently
      }
    };

    fetchAnnouncements();
  }, [API_BASE]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleMeetings = (e) => {
    e.preventDefault();
    setShowMeetings(!showMeetings);
  };

  const handleAdminPortal = (e) => {
    e.preventDefault();
    const stored = localStorage.getItem('adminUser');
    if (stored) {
      try {
        const user = JSON.parse(stored);
        if (user && (user.role === 'ADMIN' || user.email)) {
          navigate('/admin/dashboard');
          return;
        }
      } catch (_) {}
    }
    navigate('/admin/login');
  };

  return (
    <>
      <div className="announcement-button-wrapper">
        <div className="sidebar-social-icons">
          <a href="https://lbntv.org/" target="_blank" rel="noopener noreferrer" title="watch lbntv">
            <img src={twitterIcon} alt="LBN TV" />
          </a>
          <a href="https://kingschat.online" target="_blank" rel="noopener noreferrer" title="KingsChat">
            <img src={kcIcon} alt="KingsChat" />
          </a>
          <a href="https://kingsconference.org/video/home.php" target="_blank" rel="noopener noreferrer" title="KingsConference">
            <img src={kcConfIcon} alt="KingsConference" />
          </a>
          <div className="meetings-wrapper">
            <a href="#meetings" onClick={toggleMeetings} title="Join a Meeting">
              <img src={fccIcon} alt="FreeConferenceCall" />
            </a>
            {showMeetings && (
              <div className="meetings-dropdown">
                <h4>Join a Meeting</h4>
                <p className="meetings-help-text">💡 Tip: Please choose the 'Web Version' when joining.</p>
                <a href="https://join.freeconferencecall.com/ceindiazone2" target="_blank" rel="noopener noreferrer">CE India Zone 2</a>
                <a href="https://join.freeconferencecall.com/cepune" target="_blank" rel="noopener noreferrer">CE Pune</a>
                <a href="https://join.freeconferencecall.com/nancymat7" target="_blank" rel="noopener noreferrer">Nancy Mat7</a>
                <a href="https://join.freeconferencecall.com/cepunechoir5" target="_blank" rel="noopener noreferrer">CE Pune Choir</a>
                <a href="https://join.freeconferencecall.com/pune-justice" target="_blank" rel="noopener noreferrer">Pune Justice</a>
              </div>
            )}
          </div>
          <a
            href="/admin/login"
            onClick={handleAdminPortal}
            className="sidebar-admin-btn"
            title="Admin Portal - Login Directly"
            aria-label="Admin Portal Login"
          >
            <div className="admin-icon-container">
              <svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="adminBg" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1E3C72" />
                    <stop offset="0.5" stopColor="#136488" />
                    <stop offset="1" stopColor="#0B1B2B" />
                  </linearGradient>
                  <linearGradient id="adminGold" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFE066" />
                    <stop offset="1" stopColor="#F59E0B" />
                  </linearGradient>
                  <linearGradient id="adminShield" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#5DB3E8" />
                    <stop offset="1" stopColor="#136488" />
                  </linearGradient>
                </defs>
                <circle cx="16" cy="16" r="14.5" fill="url(#adminBg)" stroke="#5DB3E8" strokeWidth="1.4" />
                <path
                  d="M16 6.5L23 9.5V16.5C23 21.2 20 24.8 16 26.5C12 24.8 9 21.2 9 16.5V9.5L16 6.5Z"
                  fill="rgba(19, 100, 136, 0.45)"
                  stroke="url(#adminShield)"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M13 11L14 13L16 11.5L18 13L19 11L18.5 14H13.5L13 11Z"
                  fill="url(#adminGold)"
                  stroke="#F59E0B"
                  strokeWidth="0.5"
                />
                <path
                  d="M14.5 17.5V15.5C14.5 14.67 15.17 14 16 14C16.83 14 17.5 14.67 17.5 15.5V17.5"
                  stroke="url(#adminGold)"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                />
                <rect x="13" y="17.5" width="6" height="5" rx="1.2" fill="url(#adminGold)" />
                <circle cx="16" cy="19.3" r="0.8" fill="#0B1B2B" />
                <path d="M16 19.8V21.2" stroke="#0B1B2B" strokeWidth="0.8" strokeLinecap="round" />
              </svg>
            </div>
          </a>
        </div>
        <button className="announcement-toggle" onClick={toggleSidebar}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
          <span className="notification-badge">{announcements.length}</span>
        </button>
      </div>

      <div className={`announcement-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h3>📢 Announcements</h3>
          <button className="close-btn" onClick={toggleSidebar}>×</button>
        </div>
        <ul>
          {announcements.map((item) => (
            <li key={item.id}>
              <span className="announcement-icon">{item.icon}</span>
              <div className="announcement-content">
                <strong>{item.title}</strong>
                <p>{item.subtitle}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default SidebarToggle;
